import React, { useState, useCallback, useEffect } from "react";

import SlickSlider from "react-slick";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useLocation, useHistory, withRouter } from 'react-router-dom';
import { connect } from "react-redux";
import Swal from "sweetalert2";

import { formateDate } from '../../utils/formatDate';

import { makeStyles } from '@material-ui/core/styles';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import Typography from '@material-ui/core/Typography';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import { Container } from "../../components/design/layout/container";
import MobileView from "../../components/design/layout/mobile";
import Button from "../../components/design/form/button";

import { FontAwesomeIcon as Icon } from '@fortawesome/react-fontawesome';

import {
    Wrapper,
    Top,
    ProductGallery,
    Discount,
    DiscountValue,
    OffText,
    Informations,
    LikeArea,
    StoreTitle,
    ProductTitle,
    ProductPrice,
    WrappBuyButton,
    LikeButton,
    Bottom,
    Description,
    DescriptionTitle,
    DescriptionText,
    RulesAndInformations,
    AccordionContent,
    AccordionContentItem,
    ItemCheck,
    LoadMoreButton,
    StoreListItem,
    ShowDate
} from "./styles";

import OfferService from "../../services/Offer";
import OfferEvaluationsService from "../../services/OfferEvaluations";

import loadImage from "../../utils/LoadImage";
import handleURLParams from './../../utils/handleURLParams';

import ProductPlaceholder from "../../assets/images/placeholders/product-458x406.png";

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        boxShadow: 'none !important',
        borderBottom: '1px solid #F1F1F1',
        margin: '0 !important',
        '&::before': {
            backgroundColor: 'transparent'
        }
    },
    heading: {
        fontSize: theme.typography.pxToRem(14),
        fontWeight: theme.typography.fontWeightBold,
        fontFamily: `'Nunito', sans-serif`,
        color: `#3A3E4A`
    },
    text: {
        fontSize: theme.typography.pxToRem(13),
        fontWeight: theme.typography.fontWeightMedium,
        fontFamily: `'Nunito', sans-serif`,
        color: `#515157`,
    },
    icon: {
        padding: '8px'
    }
}));

function Offer({ website }) {
    const classes = useStyles();
    const history = useHistory();
    const location = useLocation();
    const search = new URLSearchParams(location.search);
    const productId = search.get('productId');

    const [product, setProduct] = useState({});
    const [evaluation, setEvaluation] = useState(null);
    const [loadMoreStores, setLoadMoreStores] = useState(3);

    const params = {
        dots: true,
        infinite: false,
        autoplay: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false
    };

    const handleLoadMoreStores = ({ increment = false, decrement = false }) => {

        if (increment) {
            setLoadMoreStores(prev => prev + 3)
        }

        if (decrement) {
            setLoadMoreStores(prev => prev = 3)
        }
    };

    const evaluationOffer = ({ action }) => {
        const offerEvaluationsService = new OfferEvaluationsService();

        offerEvaluationsService.insertEvaluation({
            action: action,
            offer: productId
        }).then((response) => {
            if (response.data.type === 'success') setEvaluation(action);
        })
    };

    const handleActiveOffer = ({ offerId }) => {
        const offerService = new OfferService();

        offerService.activeOffer({ offerId: offerId }).then((response) => {
            if (response.data.type === 'success') {
                Swal.fire({
                    icon: "success",
                    html: response.data.message,
                    title: "",
                });
                return history.push({ pathname: '/ofertas-ativas', search: history.location.search });
            } else {
                Swal.fire({
                    icon: "info",
                    html: response.data.message,
                    title: "",
                });
            }
        }).catch(err => {
            Swal.fire({
                icon: "error",
                html: err.message,
                title: "",
            });
        });
    }

    const hendleSearchProduct = useCallback(() => {
        const offerService = new OfferService();

        if (productId) {

            offerService.findByID({ offerID: productId }).then((response) => {
                setProduct(response.data.payload);
                setEvaluation(response.data.payload.avaliacao);
            });
        }

    }, [productId]);

    useEffect(() => {
        hendleSearchProduct();
    }, [hendleSearchProduct]);

    useEffect(() => {
        return function cleanup() {
            handleURLParams({
                listOfKeyValues: [
                    { key: 'productId', value: undefined },
                ],
                location: history.location,
                history: history
            })
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <MobileView pageTitle="Voltar" activeBackHistory={true} contentMarginTop={46}>
                <Wrapper>
                    {Object.entries(product).length !== 0 && (
                        <>
                            <Top>
                                <ProductGallery>
                                    {product.desconto && (
                                        <Discount>
                                            <DiscountValue>
                                                {product.desconto}%
                                            </DiscountValue>
                                            <OffText>off</OffText>
                                        </Discount>
                                    )}

                                    <SlickSlider {...params} className="ReactSlick ProductGallery">
                                        {product.imagens.map((item, index) => (
                                            <div key={`${item}-${index}`} className="slider-item" ket={index}>
                                                <picture>
                                                    <LazyLoadImage
                                                        onError={(e) => e.target.src = ProductPlaceholder}
                                                        src={loadImage({ imageCode: item })}
                                                        alt="Image"
                                                    />
                                                </picture>
                                            </div>
                                        ))}
                                    </SlickSlider>
                                </ProductGallery>
                                <Informations>
                                    <Container withContainer={true}>
                                        <LikeArea>
                                            <LikeButton
                                                onClick={() => evaluationOffer({ action: 'like' })}
                                                type="button"
                                                activeBackground={evaluation === 'like'
                                                    ? props => props.theme[website]?.pages.offer.likeUpBg
                                                    : false}
                                                activeIconColor={evaluation === 'like' ?
                                                    props => props.theme[website]?.pages.offer.likeUpColor
                                                    : ''}
                                            >
                                                {evaluation === 'like'
                                                    ? <Icon icon={["fas", "thumbs-up"]} />
                                                    : <Icon icon={["fal", "thumbs-up"]} />
                                                }
                                            </LikeButton>
                                            <LikeButton
                                                onClick={() => evaluationOffer({ action: 'deslike' })}
                                                type="button"
                                                activeBackground={evaluation === 'deslike' ? "#FDE9EB" : false}
                                                buttonType="deslike"
                                                activeIconColor={evaluation === 'deslike' && "#EF3742"}
                                            >

                                                {evaluation === 'deslike'
                                                    ? <Icon icon={["fas", "thumbs-up"]} />
                                                    : <Icon icon={["fal", "thumbs-up"]} />
                                                }
                                            </LikeButton>
                                        </LikeArea>

                                        <StoreTitle>
                                            {product.parceiro ? product.parceiro.nome : product.empresa?.nome}
                                        </StoreTitle>
                                        <ProductTitle>
                                            {product.titulo}
                                        </ProductTitle>

                                        <ProductPrice
                                            producPriceColor={props => props.theme[website]?.pages.offer.priceTextColor}
                                        >
                                            {product.oferta}
                                        </ProductPrice>

                                        <WrappBuyButton>

                                            {product.tipo_oferta !== 'divulgacao' ? (

                                                <Button
                                                    styleType="bordered"
                                                    buttonSize="small"
                                                    buttonColor={props => props.theme[website]?.pages.offer.callToAction}
                                                    textColor="#FFFFFF"
                                                    buttonText={!product?.oferta_ativa_usuario
                                                        ? "Resgatar"
                                                        : "Oferta já resgatada"
                                                    }
                                                    borderColor={props => props.theme[website]?.pages.offer.callToAction}
                                                    maxWidth={200}
                                                    onClick={!product?.oferta_ativa_usuario ? () => handleActiveOffer({ offerId: product._id }) : null}
                                                    disabled={!!product?.oferta_ativa_usuario}
                                                />
                                            ) :
                                                (<></>)
                                            }
                                        </WrappBuyButton>
                                    </Container>
                                </Informations>
                            </Top>

                            <Bottom>
                                <Container withContainer={true}>

                                    {product.lojas_participantes && (
                                        <Description marginBottom>
                                            <DescriptionTitle>
                                                Lojas Participantes
                                            </DescriptionTitle>
                                            <DescriptionText>
                                            {product.lojas_participantes.length > 0 ?
                                                <>
                                                    <ul>
                                                        {product.lojas_participantes.slice(0, loadMoreStores).map(({ _id, nome }, i) => (
                                                            <>
                                                                <StoreListItem key={`${_id}`}><Icon icon={["fas", "circle"]} />{nome}</StoreListItem>
                                                            </>
                                                        ))}
                                                    </ul>

                                                    {product.lojas_participantes.length > 3 && (loadMoreStores >= product.lojas_participantes.length
                                                    ? (
                                                        <LoadMoreButton
                                                            type="button"
                                                            textColor={props => props.theme[website]?.pages.offer.priceTextColor} onClick={() => handleLoadMoreStores({ decrement: true })}
                                                        >
                                                            Ver menos <Icon icon={["fas", "minus-circle"]} />
                                                        </LoadMoreButton>
                                                    )
                                                    : (
                                                        <LoadMoreButton
                                                            type="button"
                                                            textColor={props => props.theme[website]?.pages.offer.callToAction}
                                                            onClick={() => handleLoadMoreStores({ increment: true })}
                                                        >
                                                            Ver mais lojas <Icon icon={["fas", "plus-circle"]} />
                                                        </LoadMoreButton>

                                                    ))}
                                                </>
                                            :   
                                                <>
                                                    Nenhuma loja cadastrada.
                                                </>
                                            }
                                            </DescriptionText>
                                        </Description>
                                    )}

                                    {product.descricao ?
                                        (<Description>
                                            <DescriptionTitle>
                                                Descrição
                                            </DescriptionTitle>
                                            <DescriptionText>
                                                {product.descricao}
                                            </DescriptionText>
                                        </Description>) :
                                        (<></>)
                                    }

                                    {product.validade && product.validade.data_inicio && (
                                        <ShowDate>
                                            Oferta válida de <span>{formateDate({ date: product.validade.data_inicio })}</span> até <span>{formateDate({ date: product.validade.data_fim })}</span>
                                        </ShowDate>
                                    )}

                                    <RulesAndInformations>
                                        {product.regulamento ?
                                            (<Accordion className={`${classes.root} AccordionPartnerDescription`}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel1a-content"
                                                    id="panel1a-header"
                                                >
                                                    <Typography className={classes.heading}>Regulamento</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails>
                                                    <Typography className={classes.text}>
                                                        {product.regulamento}
                                                    </Typography>
                                                </AccordionDetails>
                                            </Accordion>) :
                                            (<></>)
                                        }
                                        {product.regras ?
                                            (<Accordion className={`${classes.root} AccordionPartnerDescription`}>
                                                <AccordionSummary
                                                    expandIcon={<ExpandMoreIcon />}
                                                    aria-controls="panel2a-content"
                                                    id="panel2a-header"
                                                >
                                                    <Typography className={classes.heading}>Regras</Typography>
                                                </AccordionSummary>
                                                <AccordionDetails className="Hello">
                                                    {product.regras.length > 0 ?
                                                        <AccordionContent>
                                                            {product.regras.map((item, i) => (
                                                                <React.Fragment key={`${item}-${i}`}>
                                                                    <AccordionContentItem>
                                                                        <ItemCheck iconColor={props => props.theme[website]?.pages.offer.callToAction}>
                                                                            <Icon icon={["far", "check"]} />
                                                                        </ItemCheck>
                                                                        <DescriptionText>
                                                                            {item}
                                                                        </DescriptionText>
                                                                    </AccordionContentItem>
                                                                </React.Fragment>
                                                            ))}
                                                        </AccordionContent>
                                                        :
                                                        <>
                                                            <DescriptionText>
                                                                Nenhuma regra aplicada.
                                                            </DescriptionText>
                                                        </>
                                                    }
                                                </AccordionDetails>
                                            </Accordion>) :
                                            (<></>)
                                        }
                                    </RulesAndInformations>
                                </Container>
                            </Bottom>
                        </>
                    )}
                </Wrapper>
            </MobileView>
        </>
    )
}

const mapStateToProps = (state) => {
    return {
        scamber: state.scamberReducer.scamber,
        website: state.websiteReducer.website
    };
};

export default withRouter(connect(mapStateToProps)(Offer));